module.exports = __webpack_public_path__ + "media/images/Estelle01A-3d768dac.png";